import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PaginationState } from '../../models/pagination';

type WhatsappCampaignsListState = {
  pagination: PaginationState;
};

type EmailCampaignsListState = {
  pagination: PaginationState;
};

type SmsCampaignsListState = {
  pagination: PaginationState;
};

type AudiencesState = {
  ui: {
    /** Omitted in persisted state from builds before this branch; use optional access + defaults when reading. */
    whatsappCampaigns?: WhatsappCampaignsListState;
    emailCampaigns?: EmailCampaignsListState;
    smsCampaigns?: SmsCampaignsListState;
  };
};

export const initialState: AudiencesState = {
  ui: {
    whatsappCampaigns: {
      pagination: {
        pageNo: 0,
        pageSize: 0,
      },
    },
    emailCampaigns: {
      pagination: {
        pageNo: 0,
        pageSize: 0,
      },
    },
    smsCampaigns: {
      pagination: {
        pageNo: 0,
        pageSize: 0,
      },
    },
  },
};

const campaignsSlice = createSlice({
  name: 'campaigns',
  initialState,
  reducers: {
    setWhatsappCampaignsPagination: (state, action: PayloadAction<PaginationState>) => ({
      ...state,
      ui: {
        ...state.ui,
        whatsappCampaigns: {
          ...(state.ui.whatsappCampaigns ?? initialState.ui.whatsappCampaigns),
          pagination: action.payload,
        },
      },
    }),
    setEmailCampaignsPagination: (state, action: PayloadAction<PaginationState>) => ({
      ...state,
      ui: {
        ...state.ui,
        emailCampaigns: {
          ...(state.ui.emailCampaigns ?? initialState.ui.emailCampaigns),
          pagination: action.payload,
        },
      },
    }),
    setSmsCampaignsPagination: (state, action: PayloadAction<PaginationState>) => ({
      ...state,
      ui: {
        ...state.ui,
        smsCampaigns: {
          ...(state.ui.smsCampaigns ?? initialState.ui.smsCampaigns),
          pagination: action.payload,
        },
      },
    }),
  },
});

export const { setWhatsappCampaignsPagination, setEmailCampaignsPagination, setSmsCampaignsPagination } = campaignsSlice.actions;

export default campaignsSlice.reducer;
